import { FormResult } from "./FormRender";
import { SmartFormSetup } from "./SmartFormSetup";
import apiFetch from "@wordpress/api-fetch";
import { SmartFormField } from "./SmartFormField";

export class SmartForm {
  getField(blockId: string, smartProp: string): SmartFormField | undefined {
    return this.setup?.fields.find(
      (field) => field.blockId === blockId && field.smartProp === smartProp
    );
  }

  registerField(fieldSetup: SmartFormField) {
    this.updateSetup({
      fields: [
        ...(this.setup?.fields ?? []).filter(
          (field) => !this.isSameField(field, fieldSetup)
        ),
        fieldSetup,
      ],
      configuration: this.setup?.configuration ?? {},
    });
  }

  private isSameField(field: SmartFormField, fieldSetup: SmartFormField) {
    return (
      field.blockId === fieldSetup.blockId &&
      field.smartProp === fieldSetup.smartProp
    );
  }

  unregisterField(fieldSetup: SmartFormField) {
    this.updateSetup({
      fields: (this.setup?.fields ?? []).filter(
        (field) => !this.isSameField(field, fieldSetup)
      ),
      configuration: this.setup?.configuration ?? {},
    });
  }

  async submit(formData: FormData): Promise<FormResult> {
    try {
      const result: FormResult = await apiFetch({
        path: "smartforms/v1/submit",
        method: "POST",
        body: formData,
      });
      return {
        success: true,
        message: result.message,
      };
    } catch (e: any) {
      if (e.success === false) {
        return {
          success: false,
          errors: e.errors,
        };
      } else {
        throw e;
      }
    }
  }

  get configuration(): SmartFormSetup["configuration"] {
    return (
      this.setup?.configuration ?? {
        emailTo: "",
        subject: "",
        message: "",
        headers: "",
      }
    );
  }

  setConfiguration(configuration: SmartFormSetup["configuration"]) {
    this.updateSetup({
      fields: this.setup?.fields ?? [],
      configuration,
    });
  }

  get fields() {
    return this.setup?.fields ?? [];
  }

  constructor(
    protected setup: SmartFormSetup | undefined,
    protected updateSetup: (setup: SmartFormSetup) => void
  ) {}

  needInit() {
    return this.setup === undefined;
  }

  init() {
    this.updateSetup({
      fields: this.setup?.fields ?? [],
      configuration: this.setup?.configuration ?? {},
    });
  }

  get formConfig() {
    return this.setup?.formConfig;
  }
}
